import React, { FC, useCallback } from 'react'
import styles from 'styles/components/modal.module.scss'
import text from 'styles/utility/text.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'index'
import { getStoreSwitchName, getStoreSwitchOpen, getStoreSwitchRef, getShopSwitchRef } from 'reducks/modal/selectors'
import { Spacer } from 'components/Utility'
import { Description } from 'components/Typography'
import { FlexRow } from 'components/Flex'
import { Card, CardInner } from 'components/Card'
import { GreyButton, OrangeButton } from 'components/Button'
import { closeStoreSwitchModal } from 'reducks/modal/operations'
import { switchStoreRef } from 'reducks/auth/operations'
import { FirebaseDocRefType } from 'firebase/index'
import { closeSubHeader } from 'reducks/nav/operations'

const StoreSwitchModal: FC = () => {
  const dispatch = useDispatch()

  const storeName = useSelector((state: State) => getStoreSwitchName(state))
  const switchToShopRef: FirebaseDocRefType | undefined = useSelector((state: State) => getShopSwitchRef(state))
  const switchToStoreRef: FirebaseDocRefType | undefined = useSelector((state: State) => getStoreSwitchRef(state))
  const open = useSelector((state: State) => getStoreSwitchOpen(state))

  const closeModalCallback = useCallback(() => dispatch(closeStoreSwitchModal()), [dispatch])

  return (
    <div className={open ? styles.open : ''}>
      <div className={styles.overlay}>
        <div className={styles.overlay__background} onClick={closeModalCallback} />
        {open && (
          <div className={styles.overlay__container}>
            <Card>
              <CardInner>
                <p className={`${text.color_orange_main} ${text.font_large} ${text.font_bold}`}>
                  {storeName}に切り替える
                </p>
                <Spacer size={16} />
                <Description description={`${storeName}向けの管理画面に切り替えます。`} />
                <Spacer size={20} />
                <FlexRow justifyContent={'center'}>
                  <GreyButton label={'キャンセル'} onClick={closeModalCallback} size={'small'} type={'outlined'} />
                  <Spacer size={24} axis={'horizontal'} />
                  <OrangeButton
                    label={'切り替える'}
                    onClick={() => {
                      // 生産店舗 or 横断モードの切り替え
                      dispatch(switchStoreRef(switchToStoreRef, undefined, switchToShopRef, false))
                      dispatch(closeStoreSwitchModal())
                      dispatch(closeSubHeader())
                    }}
                    size={'small'}
                    type={'main'}
                  />
                </FlexRow>
              </CardInner>
            </Card>
          </div>
        )}
      </div>
    </div>
  )
}

export default StoreSwitchModal
